module.exports = __webpack_public_path__ + "img/ico-switch.2123b268.svg";